<script setup lang="ts">
import { ref, watch } from "vue"
import { vMaska } from "maska/vue"

const props = defineProps<{
  modelValue: string
  mask: any
  reversed?: boolean
  disabled?: boolean
}>()

const maskInputOptions = {
  mask: props.mask,
  reversed: props.reversed ?? false,
}

const emit = defineEmits(["update:modelValue"])
const inputValue = ref(props.modelValue)

watch(
  () => props.modelValue,
  (v) => (inputValue.value = v),
)
watch(
  () => props.mask,
  (v) => (maskInputOptions.mask = v),
)
watch(inputValue, (v) => emit("update:modelValue", v))
</script>

<template>
  <VaInput v-model="inputValue" v-maska="maskInputOptions" :disabled="props.disabled" />
</template>
